module.exports = __webpack_public_path__ + "static/media/logoPalanka.2fd77d2c.png";